class AckMedical {
    constructor(apiService = null) {
        this.obj_name = 'ackMedical';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                // GET 請求
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                // POST 請求
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    // 照養 | 101取得照養紀錄
    

    // 共用 | 103更新資訊
    async updDeathReferralShelter(parameter, progressEvent = null) {
        return this.callApi('post', 'updDeathReferralShelter', parameter, progressEvent);
    }

}

export default AckMedical;
